import { render, staticRenderFns } from "./view-history.vue?vue&type=template&id=e11809d2&"
import script from "./view-history.vue?vue&type=script&lang=js&"
export * from "./view-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports